import {
    RESET_MESSAGES
  } from "./type";
  
  export const resetMessage = () => async (dispatch) => {
      dispatch({ type: RESET_MESSAGES});
        
  }
  